import React from 'react'
import { Link } from 'react-router-dom'
import { Icon } from '@iconify/react';
import Div from '../Div';

export default function SocialWidget() {
  return (
    <Div className="cs-social_btns cs-style1">
      <Link to='https://www.linkedin.com/company/lixrinnovation/' className="cs-center">
        <Icon icon="fa6-brands:linkedin-in" />
      </Link>
      <Link to='https://x.com/lixrinnova?s=11' className="cs-center">
        <Icon icon="fa6-brands:x-twitter" />               
      </Link>
      {/* <Link to='/' className="cs-center">
        <Icon icon="fa6-brands:youtube" />              
      </Link> */}
      <Link to='https://www.facebook.com/share/16DuTzTF6H/' className="cs-center">
        <Icon icon="fa6-brands:facebook-f" />
      </Link>
    </Div>
  )
}
